import React from 'react';

import type { SVGProps } from 'react';

const ChainIcon: React.FC<SVGProps<any>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.07214 9.81409L5.0145 11.8717C3.25714 13.6291 3.25714 16.4783 5.0145 18.2357C6.77186 19.9931 9.6211 19.9931 11.3785 18.2357L14.1211 15.4931C15.8785 13.7357 15.8785 10.8864 14.1211 9.12909C13.7492 8.75718 13.3284 8.46398 12.8794 8.24949L11.9998 9.12909C11.9083 9.22056 11.8311 9.3209 11.7682 9.42734C12.2414 9.56292 12.6877 9.81705 13.0604 10.1897C14.232 11.3613 14.232 13.2608 13.0604 14.4324L10.3178 17.175C9.14623 18.3466 7.24673 18.3466 6.07516 17.175C4.90359 16.0035 4.90359 14.104 6.07516 12.9324L7.26407 11.7435C7.09578 11.1133 7.0318 10.4611 7.07214 9.81409Z"
      fill="currentColor"
    />
    <path
      d="M9.87846 7.00777C8.1211 8.76513 8.1211 11.6144 9.87846 13.3717C10.2504 13.7436 10.6712 14.0368 11.1202 14.2513L12.2836 13.0879C11.7911 12.9564 11.3255 12.6975 10.9391 12.3111C9.76755 11.1395 9.76755 9.24 10.9391 8.06843L13.6818 5.32579C14.8533 4.15422 16.7528 4.15422 17.9244 5.32579C19.096 6.49736 19.096 8.39686 17.9244 9.56843L16.7355 10.7573C16.9038 11.3875 16.9678 12.0398 16.9274 12.6867L18.9851 10.6291C20.7424 8.87173 20.7424 6.02249 18.9851 4.26513C17.2277 2.50777 14.3785 2.50777 12.6211 4.26513L9.87846 7.00777Z"
      fill="currentColor"
    />
  </svg>
);

export default ChainIcon;
